import React from 'react';
import { ArrowLeftIcon, ArrowRightIcon, CheckIcon, ShieldIcon } from 'lucide-react';
import { Link } from 'react-router-dom';
export function ColorComparisonPage() {
  return <div className="w-full bg-[#f8f8f8]" data-id="element-827">
      {/* Back button */}
      <div className="max-w-7xl mx-auto px-6 py-8" data-id="element-828">
        <Link to="/" className="flex items-center text-gray-600 hover:text-[#214ae9] transition-colors font-medium" data-id="element-829">
          <ArrowLeftIcon size={20} className="mr-2" data-id="element-830" />
          <span data-id="element-831">Go Back</span>
        </Link>
      </div>

      <div className="max-w-7xl mx-auto px-6 pb-16" data-id="element-832">
        <div className="text-center mb-12" data-id="element-833">
          <h1 className="text-4xl md:text-5xl font-bold text-[#111111] mb-4" data-id="element-834">
            Color Strategy Options
          </h1>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto" data-id="element-835">
            Explore different approaches to using your brand colors. Each option
            shows a unique hierarchy and emphasis.
          </p>
        </div>

        <div className="space-y-16" data-id="element-836">
          {/* Option 1: Blue Primary (Current) */}
          <div className="bg-white rounded-2xl overflow-hidden shadow-lg border border-gray-200" data-id="element-837">
            <div className="bg-[#1a0647] px-8 py-4 border-b border-gray-700" data-id="element-838">
              <h2 className="text-xl font-bold text-white" data-id="element-839">
                Option 1: Blue Primary
              </h2>
              <p className="text-sm text-gray-300" data-id="element-840">
                Professional and trustworthy • Current implementation
              </p>
            </div>
            <div className="p-8" data-id="element-841">
              <div className="grid grid-cols-1 lg:grid-cols-2 gap-8" data-id="element-842">
                {/* Hero preview */}
                <div className="bg-[#1a0647] rounded-xl p-8" data-id="element-843">
                  <div className="inline-block bg-[#b063ff] bg-opacity-20 text-[#b063ff] px-4 py-1.5 rounded-full text-sm font-semibold mb-6 border border-[#b063ff] border-opacity-30" data-id="element-844">
                    🚀 New Feature
                  </div>
                  <h3 className="text-3xl font-bold text-white mb-4" data-id="element-845">
                    Protect your family from digital chaos
                  </h3>
                  <p className="text-gray-300 mb-6" data-id="element-846">
                    Take control of your family's digital security with our
                    comprehensive protection tools.
                  </p>
                  <div className="flex flex-wrap gap-3" data-id="element-847">
                    <button className="bg-[#214ae9] text-white px-6 py-3 rounded-lg font-bold hover:bg-[#1a3bb8] transition-all shadow-lg flex items-center space-x-2" data-id="element-848">
                      <span data-id="element-849">Get Started</span>
                      <ArrowRightIcon size={18} data-id="element-850" />
                    </button>
                    <button className="border-2 border-[#00f4f8] text-[#00f4f8] px-6 py-3 rounded-lg font-bold hover:bg-[#00f4f8] hover:text-[#1a0647] transition-all" data-id="element-851">
                      Learn More
                    </button>
                  </div>
                </div>
                {/* Feature cards */}
                <div className="space-y-4" data-id="element-852">
                  <div className="bg-[#f8f8f8] rounded-xl p-6 border border-gray-200" data-id="element-853">
                    <div className="w-12 h-12 bg-[#214ae9] bg-opacity-10 rounded-xl flex items-center justify-center mb-4" data-id="element-854">
                      <ShieldIcon className="w-6 h-6 text-[#214ae9]" data-id="element-855" />
                    </div>
                    <h4 className="text-lg font-bold text-[#111111] mb-2" data-id="element-856">
                      Comprehensive Protection
                    </h4>
                    <p className="text-gray-600 text-sm" data-id="element-857">
                      All the tools you need in one place
                    </p>
                  </div>
                  <div className="bg-[#f8f8f8] rounded-xl p-6 border border-gray-200" data-id="element-858">
                    <div className="w-12 h-12 bg-[#b063ff] bg-opacity-10 rounded-xl flex items-center justify-center mb-4" data-id="element-859">
                      <CheckIcon className="w-6 h-6 text-[#b063ff]" data-id="element-860" />
                    </div>
                    <h4 className="text-lg font-bold text-[#111111] mb-2" data-id="element-861">
                      Easy to Use
                    </h4>
                    <p className="text-gray-600 text-sm" data-id="element-862">
                      Simple setup in minutes
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Option 2: Purple Primary */}
          <div className="bg-white rounded-2xl overflow-hidden shadow-lg border border-gray-200" data-id="element-863">
            <div className="bg-[#b063ff] px-8 py-4 border-b border-purple-400" data-id="element-864">
              <h2 className="text-xl font-bold text-white" data-id="element-865">
                Option 2: Purple Primary
              </h2>
              <p className="text-sm text-white text-opacity-90" data-id="element-866">
                Modern and energetic • Bold personality
              </p>
            </div>
            <div className="p-8" data-id="element-867">
              <div className="grid grid-cols-1 lg:grid-cols-2 gap-8" data-id="element-868">
                {/* Hero preview */}
                <div className="bg-[#1a0647] rounded-xl p-8" data-id="element-869">
                  <div className="inline-block bg-[#00f4f8] bg-opacity-20 text-[#00f4f8] px-4 py-1.5 rounded-full text-sm font-semibold mb-6 border border-[#00f4f8] border-opacity-30" data-id="element-870">
                    🚀 New Feature
                  </div>
                  <h3 className="text-3xl font-bold text-white mb-4" data-id="element-871">
                    Protect your family from digital chaos
                  </h3>
                  <p className="text-gray-300 mb-6" data-id="element-872">
                    Take control of your family's digital security with our
                    comprehensive protection tools.
                  </p>
                  <div className="flex flex-wrap gap-3" data-id="element-873">
                    <button className="bg-[#b063ff] text-white px-6 py-3 rounded-lg font-bold hover:bg-[#9b4ee6] transition-all shadow-lg flex items-center space-x-2" data-id="element-874">
                      <span data-id="element-875">Get Started</span>
                      <ArrowRightIcon size={18} data-id="element-876" />
                    </button>
                    <button className="border-2 border-[#214ae9] text-[#214ae9] px-6 py-3 rounded-lg font-bold hover:bg-[#214ae9] hover:text-white transition-all" data-id="element-877">
                      Learn More
                    </button>
                  </div>
                </div>
                {/* Feature cards */}
                <div className="space-y-4" data-id="element-878">
                  <div className="bg-[#f8f8f8] rounded-xl p-6 border border-gray-200" data-id="element-879">
                    <div className="w-12 h-12 bg-[#b063ff] bg-opacity-10 rounded-xl flex items-center justify-center mb-4" data-id="element-880">
                      <ShieldIcon className="w-6 h-6 text-[#b063ff]" data-id="element-881" />
                    </div>
                    <h4 className="text-lg font-bold text-[#111111] mb-2" data-id="element-882">
                      Comprehensive Protection
                    </h4>
                    <p className="text-gray-600 text-sm" data-id="element-883">
                      All the tools you need in one place
                    </p>
                  </div>
                  <div className="bg-[#f8f8f8] rounded-xl p-6 border border-gray-200" data-id="element-884">
                    <div className="w-12 h-12 bg-[#214ae9] bg-opacity-10 rounded-xl flex items-center justify-center mb-4" data-id="element-885">
                      <CheckIcon className="w-6 h-6 text-[#214ae9]" data-id="element-886" />
                    </div>
                    <h4 className="text-lg font-bold text-[#111111] mb-2" data-id="element-887">
                      Easy to Use
                    </h4>
                    <p className="text-gray-600 text-sm" data-id="element-888">
                      Simple setup in minutes
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Option 3: Cyan Primary */}
          <div className="bg-white rounded-2xl overflow-hidden shadow-lg border border-gray-200" data-id="element-889">
            <div className="bg-[#00f4f8] px-8 py-4 border-b border-cyan-300" data-id="element-890">
              <h2 className="text-xl font-bold text-[#111111]" data-id="element-891">
                Option 3: Cyan Primary
              </h2>
              <p className="text-sm text-[#111111] text-opacity-70" data-id="element-892">
                Fresh and innovative • High energy
              </p>
            </div>
            <div className="p-8" data-id="element-893">
              <div className="grid grid-cols-1 lg:grid-cols-2 gap-8" data-id="element-894">
                {/* Hero preview */}
                <div className="bg-[#1a0647] rounded-xl p-8" data-id="element-895">
                  <div className="inline-block bg-[#b063ff] bg-opacity-20 text-[#b063ff] px-4 py-1.5 rounded-full text-sm font-semibold mb-6 border border-[#b063ff] border-opacity-30" data-id="element-896">
                    🚀 New Feature
                  </div>
                  <h3 className="text-3xl font-bold text-white mb-4" data-id="element-897">
                    Protect your family from digital chaos
                  </h3>
                  <p className="text-gray-300 mb-6" data-id="element-898">
                    Take control of your family's digital security with our
                    comprehensive protection tools.
                  </p>
                  <div className="flex flex-wrap gap-3" data-id="element-899">
                    <button className="bg-[#00f4f8] text-[#111111] px-6 py-3 rounded-lg font-bold hover:bg-[#00d9dd] transition-all shadow-lg flex items-center space-x-2" data-id="element-900">
                      <span data-id="element-901">Get Started</span>
                      <ArrowRightIcon size={18} data-id="element-902" />
                    </button>
                    <button className="border-2 border-[#b063ff] text-[#b063ff] px-6 py-3 rounded-lg font-bold hover:bg-[#b063ff] hover:text-white transition-all" data-id="element-903">
                      Learn More
                    </button>
                  </div>
                </div>
                {/* Feature cards */}
                <div className="space-y-4" data-id="element-904">
                  <div className="bg-[#f8f8f8] rounded-xl p-6 border border-gray-200" data-id="element-905">
                    <div className="w-12 h-12 bg-[#00f4f8] bg-opacity-10 rounded-xl flex items-center justify-center mb-4" data-id="element-906">
                      <ShieldIcon className="w-6 h-6 text-[#00f4f8]" data-id="element-907" />
                    </div>
                    <h4 className="text-lg font-bold text-[#111111] mb-2" data-id="element-908">
                      Comprehensive Protection
                    </h4>
                    <p className="text-gray-600 text-sm" data-id="element-909">
                      All the tools you need in one place
                    </p>
                  </div>
                  <div className="bg-[#f8f8f8] rounded-xl p-6 border border-gray-200" data-id="element-910">
                    <div className="w-12 h-12 bg-[#214ae9] bg-opacity-10 rounded-xl flex items-center justify-center mb-4" data-id="element-911">
                      <CheckIcon className="w-6 h-6 text-[#214ae9]" data-id="element-912" />
                    </div>
                    <h4 className="text-lg font-bold text-[#111111] mb-2" data-id="element-913">
                      Easy to Use
                    </h4>
                    <p className="text-gray-600 text-sm" data-id="element-914">
                      Simple setup in minutes
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Option 4: Balanced Trio */}
          <div className="bg-white rounded-2xl overflow-hidden shadow-lg border border-gray-200" data-id="element-915">
            <div className="bg-gradient-to-r from-[#214ae9] via-[#b063ff] to-[#00f4f8] px-8 py-4" data-id="element-916">
              <h2 className="text-xl font-bold text-white" data-id="element-917">
                Option 4: Balanced Trio
              </h2>
              <p className="text-sm text-white text-opacity-90" data-id="element-918">
                Equal emphasis • Vibrant and dynamic
              </p>
            </div>
            <div className="p-8" data-id="element-919">
              <div className="grid grid-cols-1 lg:grid-cols-2 gap-8" data-id="element-920">
                {/* Hero preview */}
                <div className="bg-[#1a0647] rounded-xl p-8" data-id="element-921">
                  <div className="inline-block bg-white bg-opacity-10 text-white px-4 py-1.5 rounded-full text-sm font-semibold mb-6 border border-white border-opacity-20" data-id="element-922">
                    🚀 New Feature
                  </div>
                  <h3 className="text-3xl font-bold text-white mb-4" data-id="element-923">
                    Protect your family from digital chaos
                  </h3>
                  <p className="text-gray-300 mb-6" data-id="element-924">
                    Take control of your family's digital security with our
                    comprehensive protection tools.
                  </p>
                  <div className="flex flex-wrap gap-3" data-id="element-925">
                    <button className="bg-gradient-to-r from-[#214ae9] to-[#b063ff] text-white px-6 py-3 rounded-lg font-bold hover:shadow-xl transition-all shadow-lg flex items-center space-x-2" data-id="element-926">
                      <span data-id="element-927">Get Started</span>
                      <ArrowRightIcon size={18} data-id="element-928" />
                    </button>
                    <button className="border-2 border-[#00f4f8] text-[#00f4f8] px-6 py-3 rounded-lg font-bold hover:bg-[#00f4f8] hover:text-[#1a0647] transition-all" data-id="element-929">
                      Learn More
                    </button>
                  </div>
                </div>
                {/* Feature cards */}
                <div className="space-y-4" data-id="element-930">
                  <div className="bg-[#f8f8f8] rounded-xl p-6 border-2 border-[#214ae9]" data-id="element-931">
                    <div className="w-12 h-12 bg-[#214ae9] rounded-xl flex items-center justify-center mb-4" data-id="element-932">
                      <ShieldIcon className="w-6 h-6 text-white" data-id="element-933" />
                    </div>
                    <h4 className="text-lg font-bold text-[#111111] mb-2" data-id="element-934">
                      Comprehensive Protection
                    </h4>
                    <p className="text-gray-600 text-sm" data-id="element-935">
                      All the tools you need in one place
                    </p>
                  </div>
                  <div className="bg-[#f8f8f8] rounded-xl p-6 border-2 border-[#b063ff]" data-id="element-936">
                    <div className="w-12 h-12 bg-[#b063ff] rounded-xl flex items-center justify-center mb-4" data-id="element-937">
                      <CheckIcon className="w-6 h-6 text-white" data-id="element-938" />
                    </div>
                    <h4 className="text-lg font-bold text-[#111111] mb-2" data-id="element-939">
                      Easy to Use
                    </h4>
                    <p className="text-gray-600 text-sm" data-id="element-940">
                      Simple setup in minutes
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Option 5: High Contrast */}
          <div className="bg-white rounded-2xl overflow-hidden shadow-lg border border-gray-200" data-id="element-941">
            <div className="bg-[#111111] px-8 py-4 border-b border-gray-800" data-id="element-942">
              <h2 className="text-xl font-bold text-white" data-id="element-943">
                Option 5: High Contrast
              </h2>
              <p className="text-sm text-gray-400" data-id="element-944">
                Bold and striking • Maximum impact
              </p>
            </div>
            <div className="p-8" data-id="element-945">
              <div className="grid grid-cols-1 lg:grid-cols-2 gap-8" data-id="element-946">
                {/* Hero preview */}
                <div className="bg-[#111111] rounded-xl p-8 border-2 border-[#00f4f8]" data-id="element-947">
                  <div className="inline-block bg-[#00f4f8] text-[#111111] px-4 py-1.5 rounded-full text-sm font-bold mb-6" data-id="element-948">
                    🚀 New Feature
                  </div>
                  <h3 className="text-3xl font-bold text-white mb-4" data-id="element-949">
                    Protect your family from digital chaos
                  </h3>
                  <p className="text-gray-300 mb-6" data-id="element-950">
                    Take control of your family's digital security with our
                    comprehensive protection tools.
                  </p>
                  <div className="flex flex-wrap gap-3" data-id="element-951">
                    <button className="bg-[#00f4f8] text-[#111111] px-6 py-3 rounded-lg font-bold hover:bg-white transition-all shadow-lg flex items-center space-x-2" data-id="element-952">
                      <span data-id="element-953">Get Started</span>
                      <ArrowRightIcon size={18} data-id="element-954" />
                    </button>
                    <button className="bg-[#b063ff] text-white px-6 py-3 rounded-lg font-bold hover:bg-[#9b4ee6] transition-all shadow-lg" data-id="element-955">
                      Learn More
                    </button>
                  </div>
                </div>
                {/* Feature cards */}
                <div className="space-y-4" data-id="element-956">
                  <div className="bg-[#111111] rounded-xl p-6 border-2 border-[#214ae9]" data-id="element-957">
                    <div className="w-12 h-12 bg-[#214ae9] rounded-xl flex items-center justify-center mb-4" data-id="element-958">
                      <ShieldIcon className="w-6 h-6 text-white" data-id="element-959" />
                    </div>
                    <h4 className="text-lg font-bold text-white mb-2" data-id="element-960">
                      Comprehensive Protection
                    </h4>
                    <p className="text-gray-400 text-sm" data-id="element-961">
                      All the tools you need in one place
                    </p>
                  </div>
                  <div className="bg-[#111111] rounded-xl p-6 border-2 border-[#b063ff]" data-id="element-962">
                    <div className="w-12 h-12 bg-[#b063ff] rounded-xl flex items-center justify-center mb-4" data-id="element-963">
                      <CheckIcon className="w-6 h-6 text-white" data-id="element-964" />
                    </div>
                    <h4 className="text-lg font-bold text-white mb-2" data-id="element-965">
                      Easy to Use
                    </h4>
                    <p className="text-gray-400 text-sm" data-id="element-966">
                      Simple setup in minutes
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Option 6: Light & Airy */}
          <div className="bg-white rounded-2xl overflow-hidden shadow-lg border border-gray-200" data-id="element-967">
            <div className="bg-white px-8 py-4 border-b-2 border-[#214ae9]" data-id="element-968">
              <h2 className="text-xl font-bold text-[#111111]" data-id="element-969">
                Option 6: Light & Airy
              </h2>
              <p className="text-sm text-gray-600" data-id="element-970">
                Minimal and clean • Approachable
              </p>
            </div>
            <div className="p-8" data-id="element-971">
              <div className="grid grid-cols-1 lg:grid-cols-2 gap-8" data-id="element-972">
                {/* Hero preview */}
                <div className="bg-white rounded-xl p-8 border-2 border-gray-200" data-id="element-973">
                  <div className="inline-block bg-[#214ae9] bg-opacity-5 text-[#214ae9] px-4 py-1.5 rounded-full text-sm font-semibold mb-6 border border-[#214ae9] border-opacity-20" data-id="element-974">
                    🚀 New Feature
                  </div>
                  <h3 className="text-3xl font-bold text-[#111111] mb-4" data-id="element-975">
                    Protect your family from digital chaos
                  </h3>
                  <p className="text-gray-600 mb-6" data-id="element-976">
                    Take control of your family's digital security with our
                    comprehensive protection tools.
                  </p>
                  <div className="flex flex-wrap gap-3" data-id="element-977">
                    <button className="bg-[#214ae9] text-white px-6 py-3 rounded-lg font-bold hover:bg-[#1a3bb8] transition-all shadow-md flex items-center space-x-2" data-id="element-978">
                      <span data-id="element-979">Get Started</span>
                      <ArrowRightIcon size={18} data-id="element-980" />
                    </button>
                    <button className="bg-white border-2 border-gray-300 text-[#111111] px-6 py-3 rounded-lg font-bold hover:border-[#214ae9] hover:text-[#214ae9] transition-all" data-id="element-981">
                      Learn More
                    </button>
                  </div>
                </div>
                {/* Feature cards */}
                <div className="space-y-4" data-id="element-982">
                  <div className="bg-white rounded-xl p-6 border-2 border-gray-200 hover:border-[#214ae9] transition-colors" data-id="element-983">
                    <div className="w-12 h-12 bg-[#214ae9] bg-opacity-5 rounded-xl flex items-center justify-center mb-4" data-id="element-984">
                      <ShieldIcon className="w-6 h-6 text-[#214ae9]" data-id="element-985" />
                    </div>
                    <h4 className="text-lg font-bold text-[#111111] mb-2" data-id="element-986">
                      Comprehensive Protection
                    </h4>
                    <p className="text-gray-600 text-sm" data-id="element-987">
                      All the tools you need in one place
                    </p>
                  </div>
                  <div className="bg-white rounded-xl p-6 border-2 border-gray-200 hover:border-[#b063ff] transition-colors" data-id="element-988">
                    <div className="w-12 h-12 bg-[#b063ff] bg-opacity-5 rounded-xl flex items-center justify-center mb-4" data-id="element-989">
                      <CheckIcon className="w-6 h-6 text-[#b063ff]" data-id="element-990" />
                    </div>
                    <h4 className="text-lg font-bold text-[#111111] mb-2" data-id="element-991">
                      Easy to Use
                    </h4>
                    <p className="text-gray-600 text-sm" data-id="element-992">
                      Simple setup in minutes
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>;
}